import Vue from 'vue'
import FreshVueFiles from '@freshsolutions/fresh-vue-files'
import { apolloClient } from '@/plugins/vue-apollo'
import i18n from './i18n'

Vue.use(FreshVueFiles, {
  i18n: i18n,
  apollo: apolloClient
})
